import React, {  useRef } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import '../../index.css';
import { testimonialsData } from '../../data/Data';
const Testimonials = () => {


    const containerRef = useRef(null);

    const scrollLeft = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({ left: -containerRef.current.offsetWidth, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({ left: containerRef.current.offsetWidth, behavior: 'smooth' });
        }
    };

    return (
        <section className="py-16 bg-bgpalecolor font-basefont">
            <div className="max-w-6xl mx-auto px-6 lg:px-8">
                <div className="flex justify-between items-center mb-8">
                    <h2 className="text-3xl font-bold text-basecolor">What customers say</h2>
                    <div className="flex space-x-2">
                        <button
                            className="bg-basecolor text-white rounded-full w-10 h-10 flex items-center justify-center focus:outline-none"
                            onClick={scrollLeft}
                            aria-label="Previous testimonial"
                        >
                            <FaArrowLeft className="w-5 h-5" />
                        </button>
                        <button
                            className="bg-basecolor text-white rounded-full w-10 h-10 flex items-center justify-center focus:outline-none"
                            onClick={scrollRight}
                            aria-label="Next testimonial"
                        >
                            <FaArrowRight className="w-5 h-5" />
                        </button>
                    </div>
                </div>
                <div
                    ref={containerRef}
                    className="overflow-x-auto  scroll-smooth scrollbar-hide flex gap-8 py-4"
                >
                    {testimonialsData?.map((testimonial, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-lg shadow-md p-6 w-80 sm:w-96 flex-shrink-0"
                        >
                            <p className="text-gray-700 italic mb-4">"{testimonial.quote}"</p>
                            <div className="flex items-center mt-4">
                                <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-basecolor">{testimonial.name}</h4>
                                    <p className="text-gray-600 text-sm">{testimonial.title}</p>
                                    {/* <div className="flex items-center mt-1">
                                        {testimonial.logo && (
                                            <img
                                                src={testimonial.logo}
                                                alt={testimonial.company}
                                                className="h-6 mr-2"
                                            />
                                        )}
                                        <span className="text-gray-500 text-xs">{testimonial.company}</span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;



// import React, { useRef } from 'react';
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
// import { testimonialsData } from '../../data/Data';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';

// const Testimonials = () => {
//     const containerRef = useRef(null);
//     const [ref, inView] = useInView({
//         triggerOnce: true,
//         threshold: 0.1,
//     });

//     const scrollLeft = () => {
//         if (containerRef.current) {
//             containerRef.current.scrollBy({ left: -containerRef.current.offsetWidth, behavior: 'smooth' });
//         }
//     };

//     const scrollRight = () => {
//         if (containerRef.current) {
//             containerRef.current.scrollBy({ left: containerRef.current.offsetWidth, behavior: 'smooth' });
//         }
//     };

//     const cardVariants = {
//         hidden: { opacity: 0, y: 30 },
//         visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
//     };

//     return (
//         <section className="py-16 bg-bgpalecolor font-basefont">
//             <div className="max-w-6xl mx-auto px-6 lg:px-8">
//                 <div className="flex justify-between items-center mb-8">
//                     <h2 className="text-3xl font-bold text-basecolor">What customers say</h2>
//                     <div className="flex space-x-2">
//                         <button
//                             className="bg-basecolor text-white rounded-full w-10 h-10 flex items-center justify-center focus:outline-none"
//                             onClick={scrollLeft}
//                             aria-label="Previous testimonial"
//                         >
//                             <FaArrowLeft className="w-5 h-5" />
//                         </button>
//                         <button
//                             className="bg-basecolor text-white rounded-full w-10 h-10 flex items-center justify-center focus:outline-none"
//                             onClick={scrollRight}
//                             aria-label="Next testimonial"
//                         >
//                             <FaArrowRight className="w-5 h-5" />
//                         </button>
//                     </div>
//                 </div>

//                 <div
//                     ref={containerRef}
//                     className="overflow-x-auto scroll-smooth scrollbar-hide flex gap-8 py-4"
//                 >
//                     {testimonialsData?.map((testimonial, index) => (
//                         <motion.div
//                             key={index}
//                             ref={ref}
//                             initial="hidden"
//                             animate={inView ? 'visible' : 'hidden'}
//                             variants={cardVariants}
//                             className="bg-white rounded-xl shadow-md p-6 w-80 sm:w-96 flex-shrink-0"
//                         >
//                             <p className="text-gray-700 italic mb-4">"{testimonial.quote}"</p>
//                             <div className="flex items-center mt-4">
//                                 <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
//                                     <img
//                                         src={testimonial.image}
//                                         alt={testimonial.name}
//                                         className="w-full h-full object-cover"
//                                     />
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-basecolor">{testimonial.name}</h4>
//                                     <p className="text-gray-600 text-sm">{testimonial.title}</p>
//                                 </div>
//                             </div>
//                         </motion.div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Testimonials;
